export const specialtyServicesStyles = {
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	gap: { xs: '0.25rem', md: '0 0.25rem' },
	pt: '0.5rem',
};
